/** Points tiers matching Flutter Customer Entry (₹2000 = 1pt base tier). */
export function calculatePoints(amount) {
  const a = Number(amount) || 0;
  if (a >= 7900) {
    return 4 + Math.floor((a - 7900) / 2000);
  }
  if (a >= 5900) return 3;
  if (a >= 3800) return 2;
  if (a >= 2000) return 1;
  return 0;
}

/** Fixed gift thresholds for customer-entry redemption guidance. */
export const CUSTOMER_REWARD_POINTS = Object.freeze([
  { points: 1000, item: "Refrigerator" },
  { points: 750, item: "Washing machine" },
  { points: 500, item: "Mobile phone" },
  { points: 250, item: "Gas stove" },
  { points: 100, item: "Dinner set" },
  { points: 50, item: "Gift box" },
]);

/** Highest reward currently eligible for given points. */
export function rewardForPoints(points) {
  const p = Number(points) || 0;
  return CUSTOMER_REWARD_POINTS.find((r) => p >= r.points) || null;
}

export function cleanPhone(phone) {
  return String(phone || "").replace(/[^\d+]/g, "");
}

export function formatInr(n) {
  const x = Number(n) || 0;
  return x.toLocaleString("en-IN", { maximumFractionDigits: 2 });
}
